import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const META = {
  "/": {
    title: "Excellent Traders Pte Ltd — Petroleum & Strategic Commodities Trading in Singapore",
    desc: "Singapore-based trading house for bitumen, lubricants, petrochemicals and strategic commodities, serving Asia and emerging markets.",
  },
  "/bitumen": {
    title: "Bitumen 60/70 & 80/100 Supplier in Singapore | Excellent Traders",
    desc: "Penetration-grade bitumen 60/70 and 80/100, cutback MC-30/MC-70 and emulsions supplied in bulk, bitutainers and drums from Singapore.",
  },
  "/lubricants": {
    title: "Lubricants & Base Oils Supplier Singapore — Unixx Engine Oils | Excellent Traders",
    desc: "Unixx synthetic engine oils, automotive, industrial and marine lubricants, and Group I base oils SN150/SN500/BS150 supplied from Singapore.",
  },
  "/petrochemicals": {
    title: "Petrochemicals Supplier Singapore — Aromatics, Solvents, Intermediates | Excellent Traders",
    desc: "Benzene, toluene, methanol, MEG and other petrochemicals traded through an ISO-tank supply chain with verified purity.",
  },
  "/contact": {
    title: "Contact Excellent Traders Pte Ltd — Request a Quote | Singapore",
    desc: "Request pricing and availability for bitumen, lubricants and petrochemicals. 60 Paya Lebar Road, Paya Lebar Square 1, Singapore 409051.",
  },
  "/admin/login": { title: "Admin Sign In — Excellent Traders Pte Ltd", desc: "Authorised staff only." },
  "/admin": { title: "Enquiry Inbox — Excellent Traders Pte Ltd", desc: "Authorised staff only." },
};

export default function PageMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = META[pathname] || META["/"];
    document.title = m.title;
    const tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", m.desc);
  }, [pathname]);
  return null;
}
